import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import VisuallyHidden from 'components/VisuallyHidden';

const EmptyState = props => {
    const { noValues } = props.localization;

    return (
        <Text
            fontSize='sm'
            textAlign='center'
            is='p'
        >
            <span aria-hidden='true'>-</span>
            <VisuallyHidden is='span'>{noValues}</VisuallyHidden>
        </Text>
    );
};

export default wrapFunctionalComponent(EmptyState, 'EmptyState');
